window.KS_SAFE_PARSE_JSON = window.KS_SAFE_PARSE_JSON || function (value, fallback) {
  try {
    const parsed = JSON.parse(value)
    return parsed == null ? fallback : parsed
  } catch (error) {
    return fallback
  }
}

// Format money
window.Shopify.formatMoney = function (cents, moneyFormat = window.kondasoft.moneyFormat) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '')
  }

  let value = ''
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/

  function defaultOption (opt, def) {
    return (typeof opt === 'undefined' ? def : opt)
  }

  function formatWithDelimiters (number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2)
    thousands = defaultOption(thousands, ',')
    decimal = defaultOption(decimal, '.')

    if (isNaN(number) || number == null) {
      return 0
    }

    number = (number / 100.0).toFixed(precision)

    const parts = number.split('.')
    const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands)
    const cents = parts[1] ? (decimal + parts[1]) : ''

    return dollars + cents
  }

  switch (moneyFormat.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2)
      break
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0)
      break
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',')
      break
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',')
      break
  }

  return moneyFormat.replace(placeholderRegex, value)
}

// Resize images
window.Shopify.resizeImage = function (src, size, crop = '') {
  return src.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, '.')
    .replace(/\.jpg|\.png|\.gif|\.jpeg/g, (match) => {
      if (crop.length) {
        crop = `_crop_${crop}`
      }
      return `_${size}${crop}${match}`
    })
}

// Calculate "xx time ago"
window.Shopify.calcTimeAgo = function (timestamp) {
  const now = new Date().getTime()
  const diff = now - timestamp

  let text

  if (diff < 60000) {
    text = window.kondasoft.times.moments
  } else if (diff < 3.6e+6) {
    const min = Math.round((diff) / 60000)
    text = min === 1
      ? `${min} ${window.kondasoft.times.minute}`
      : `${min} ${window.kondasoft.times.minutes}`
  } else if (diff < 8.64e+7) {
    const hours = Math.round((diff) / 3.6e+6)
    text = hours === 1
      ? `${hours} ${window.kondasoft.times.hour}`
      : `${hours} ${window.kondasoft.times.hours}`
  } else {
    const days = Math.round((diff) / 8.64e+7)
    text = days === 1
      ? `${days} ${window.kondasoft.times.day}`
      : `${days} ${window.kondasoft.times.days}`
  }

  return `${text} ${window.kondasoft.times.ago}`
}

// Create cookie helper fuction
window.ksCreateCookie = function (name, value, days) {
  let date, expires
  if (days) {
    date = new Date()
    date.setDate(date.getDate() + days)
    expires = '; expires=' + date.toUTCString()
  } else {
    expires = ''
  }
  document.cookie = name + '=' + value + expires + '; path=/'
}

// Lazy load autoplayed videos
const lazyVideosObserver = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.play()
      entry.target.muted = true
    }
  })
}, { rootMargin: '0px 0px 300px 0px' })
document.querySelectorAll('video[data-autoplay="true"]').forEach((el) => {
  lazyVideosObserver.observe(el)
})

// Fix - Megamenu is not closed when clicking within the fancy slideshow
document.querySelectorAll('.ks-fancy-slideshow').forEach(elem => {
  elem.addEventListener('click', () => {
    document.querySelectorAll('.mega-menu').forEach(elem => {
      elem.removeAttribute('open')
    })
    document.querySelectorAll('.header__menu-item').forEach(elem => {
      elem.setAttribute('aria-expanded', 'false')
    })
  })
})

// HTML5 accordions add animation support
document.querySelectorAll('.accordion__content').forEach(element => {
  const detailsElement = element.closest('details')
  const summaryElement = element.previousElementSibling
  
  detailsElement.classList.add('accordion__details')

  const wrapper = document.createElement('div')
  element.parentNode.insertBefore(wrapper, element)
  wrapper.appendChild(element)
  wrapper.id = element.id
  wrapper.classList = element.classList

  element.removeAttribute('id')
  element.removeAttribute('class')

  if (wrapper.classList.contains('rte')) {
    wrapper.classList.remove('rte')
    element.classList.add('rte')
  }

  summaryElement.addEventListener('click', (event) => {
    if (wrapper.classList.contains('summary-animation')) {
      wrapper.classList.remove('summary-animation', 'summary-collapsing');
      void element.offsetWidth;
      return;
    }

    const onAnimationEnd = cb => wrapper.addEventListener(
      "animationend", cb, {once: true}
    );

    requestAnimationFrame(() => wrapper.classList.add('summary-animation'));
    onAnimationEnd(() => wrapper.classList.remove('summary-animation'));

    const isDetailsOpen = detailsElement.getAttribute('open') !== null;
    if (isDetailsOpen) {
      event.preventDefault()
      wrapper.classList.add('summary-collapsing');
      onAnimationEnd(() => {
        detailsElement.removeAttribute('open');
        wrapper.classList.remove('summary-collapsing');
      })
    }
  })
})

class KsWishlistDrawer extends HTMLElement {
  constructor () {
    super()

    this.handleKeyup = this.handleKeyup.bind(this)
    this.handleOverlayClick = this.handleOverlayClick.bind(this)

    this.addEventListener('keyup', this.handleKeyup)

    const overlay = this.querySelector('.drawer__overlay')
    if (overlay) {
      overlay.addEventListener('click', this.handleOverlayClick)
    }

    this.setIconsAccessibility()
  }

  get triggerSelector () {
    return 'a[href="#ks-wishlist-drawer"]'
  }

  get wishlistContainer () {
    return this.querySelector('ks-wishlist-container')
  }

  handleKeyup (event) {
    if (event.code === 'Escape') {
      this.close()
    }
  }

  handleOverlayClick () {
    this.close()
  }

  setIconsAccessibility () {
    document.querySelectorAll(this.triggerSelector).forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault()
        this.open(link)
      })

      link.addEventListener('keydown', (event) => {
        if (event.code && event.code.toUpperCase() === 'SPACE') {
          event.preventDefault()
          this.open(link)
        }
      })
    })
  }

  updateTriggersState (isExpanded) {
    document.querySelectorAll(this.triggerSelector).forEach((link) => {
      link.setAttribute('aria-expanded', isExpanded ? 'true' : 'false')
    })
  }

  open (triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy)

    this.updateTriggersState(true)

    setTimeout(() => {
      this.classList.add('animate', 'active')
    })

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.wishlistContainer?.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : this.querySelector('.ks-wishlist-drawer')
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close')

        if (containerToTrapFocusOn && focusElement) {
          window.trapFocus(containerToTrapFocusOn, focusElement)
        }
      },
      { once: true }
    )

    document.body.classList.add('overflow-hidden')
  }

  close () {
    this.classList.remove('active')
    this.updateTriggersState(false)
    window.removeTrapFocus(this.activeElement)
    document.body.classList.remove('overflow-hidden')
  }

  setActiveElement (element) {
    this.activeElement = element
  }
}
customElements.define('ks-wishlist-drawer', KsWishlistDrawer)

class KsWishlistContainer extends HTMLElement {
  constructor () {
    super()

    this.placeholderImage = `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120" fill="none">
        <rect width="120" height="120" rx="18" fill="#F3F4F6"/>
        <path d="M34 78l15-18 14 15 10-11 13 14" stroke="#9CA3AF" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/>
        <circle cx="46" cy="43" r="8" fill="#D1D5DB"/>
      </svg>
    `)}`

    this.handleRemoveClick = this.handleRemoveClick.bind(this)
    this.handleImageError = this.handleImageError.bind(this)

    this.addEventListener('click', this.handleRemoveClick)
    this.addEventListener('error', this.handleImageError, true)

    const sanitizedWishlist = this.sanitizeWishlist(this.wishlist)
    this.wishlist = sanitizedWishlist

    this.setCountBadges()
    this.setContent()
    this.hydrateWishlistItems()
  }

  get wishlist () {
    const wishlist = window.KS_SAFE_PARSE_JSON(localStorage.getItem('ks-wishlist'), [])
    return Array.isArray(wishlist) ? wishlist : []
  }

  set wishlist (array) {
    try {
      localStorage.setItem('ks-wishlist', JSON.stringify(Array.isArray(array) ? array : []))
    } catch (error) {}
  }

  normalizeProductUrl (url = '') {
    if (typeof url !== 'string') return ''

    try {
      const resolvedUrl = new URL(url, window.location.origin)
      const pathname = resolvedUrl.pathname.replace(/\/$/, '') || resolvedUrl.pathname
      return `${pathname}${resolvedUrl.search}`
    } catch (error) {
      return url.trim()
    }
  }

  getProductJsonUrl (url = '') {
    try {
      const resolvedUrl = new URL(url, window.location.origin)
      const pathname = resolvedUrl.pathname.replace(/\/$/, '') || resolvedUrl.pathname
      return `${pathname}.js`
    } catch (error) {
      return `${url.replace(/\/$/, '')}.js`
    }
  }

  sanitizeWishlist (items = []) {
    const map = new Map()

    items.forEach((item) => {
      const normalizedItem = this.normalizeWishlistItem(item)
      if (!normalizedItem) return
      map.set(normalizedItem.url, normalizedItem)
    })

    return Array.from(map.values())
  }

  normalizeWishlistItem (item) {
    if (!item || typeof item !== 'object') return null

    const normalizedUrl = this.normalizeProductUrl(item.url)
    if (!normalizedUrl) return null

    const addedAt = Number(item.added_at)
    const price = typeof item.price === 'number'
      ? item.price
      : Number(item.price || 0)

    return {
      url: normalizedUrl,
      id: item.id || null,
      handle: typeof item.handle === 'string' ? item.handle : '',
      title: typeof item.title === 'string' ? item.title : '',
      img_src: typeof item.img_src === 'string' ? item.img_src : '',
      img_alt: typeof item.img_alt === 'string' && item.img_alt.trim().length
        ? item.img_alt
        : (typeof item.title === 'string' ? item.title : ''),
      compare_at_price: typeof item.compare_at_price === 'number'
        ? item.compare_at_price
        : Number(item.compare_at_price || 0) || null,
      price,
      price_varies: Boolean(item.price_varies),
      added_at: Number.isFinite(addedAt) && addedAt > 0 ? addedAt : Date.now()
    }
  }

  isRenderableImageSrc (src) {
    return typeof src === 'string' && src.trim().length > 0 && src.trim() !== '[object Object]'
  }

  needsHydration (product) {
    return !product.id || !product.title || !this.isRenderableImageSrc(product.img_src)
  }

  escapeHtml (value = '') {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
  }

  getImageDimensions () {
    switch (this.dataset.imgOrientation || this.dataset.imgRatio) {
      case 'ratio-4x3':
        return { width: 480, height: 360 }
      case 'ratio-3x4':
        return { width: 360, height: 480 }
      default:
        return { width: 480, height: 480 }
    }
  }

  buildImageSrc (src) {
    return this.isRenderableImageSrc(src) ? src : this.placeholderImage
  }

  getRemoveLabel () {
    return this.escapeHtml(window.kondasoft?.wishlist?.remove || 'Remove')
  }

  async fetchProductData (url, existingProduct = {}) {
    try {
      const response = await fetch(this.getProductJsonUrl(url))

      if (!response.ok) {
        throw new Error(`wishlist_product_request_failed:${response.status}`)
      }

      const product = await response.json()
      const productImage = typeof product.featured_image === 'string' && product.featured_image.length
        ? product.featured_image
        : (Array.isArray(product.images) && product.images.length ? product.images[0] : '')

      return this.normalizeWishlistItem({
        ...existingProduct,
        url,
        id: product.id,
        handle: product.handle,
        title: product.title,
        img_src: productImage || existingProduct.img_src || '',
        img_alt: product.title || existingProduct.img_alt || '',
        compare_at_price: product.compare_at_price ?? existingProduct.compare_at_price ?? null,
        price: typeof product.price === 'number' ? product.price : Number(existingProduct.price || 0),
        price_varies: Boolean(product.price_varies),
        added_at: Number(existingProduct.added_at) || Date.now()
      })
    } catch (error) {
      return this.normalizeWishlistItem(existingProduct)
    }
  }

  async hydrateWishlistItems () {
    const currentWishlist = this.sanitizeWishlist(this.wishlist)
    const hydratedWishlist = await Promise.all(
      currentWishlist.map(async (product) => {
        if (!this.needsHydration(product)) return product
        return this.fetchProductData(product.url, product)
      })
    )

    const sanitizedHydratedWishlist = this.sanitizeWishlist(hydratedWishlist)

    if (JSON.stringify(sanitizedHydratedWishlist) !== JSON.stringify(currentWishlist)) {
      this.wishlist = sanitizedHydratedWishlist
      this.setCountBadges()
      this.setContent()
    }
  }

  async setProduct (url) {
    const normalizedUrl = this.normalizeProductUrl(url)
    let wishlist = this.wishlist
    const isWishlisted = wishlist.some((elem) => elem.url === normalizedUrl)

    if (isWishlisted) {
      wishlist = wishlist.filter((elem) => elem.url !== normalizedUrl)
    } else {
      const product = await this.fetchProductData(normalizedUrl, {
        url: normalizedUrl,
        added_at: Date.now()
      })

      if (!product) return
      wishlist.push(product)
    }

    this.wishlist = this.sanitizeWishlist(wishlist)
    this.setCountBadges()
    this.setContent()
    this.hydrateWishlistItems()
  }

  setCountBadges () {
    document.querySelectorAll('.wishlist-count-bubble').forEach((elem) => {
      const countElement = elem.querySelector('span')
      if (!countElement) return

      countElement.textContent = this.wishlist.length

      if (this.wishlist.length) {
        elem.removeAttribute('hidden')
      } else {
        elem.setAttribute('hidden', 'hidden')
      }
    })
  }

  buildProductMarkup (product) {
    const { width, height } = this.getImageDimensions()
    const safeUrl = this.escapeHtml(product.url)
    const safeTitle = this.escapeHtml(product.title || 'Producto')
    const safeImageAlt = this.escapeHtml(product.img_alt || product.title || 'Producto')
    const imageSrc = this.escapeHtml(this.buildImageSrc(product.img_src))
    const addedAtText = this.escapeHtml(window.Shopify.calcTimeAgo(product.added_at))
    const addedAtIso = new Date(product.added_at).toISOString()
    const removeLabel = this.getRemoveLabel()

    return `
      <div class="ks-wishlist-drawer-product-list-item ks-grid-product-list-item" role="listitem" data-product-url="${safeUrl}">
        <a href="${safeUrl}" class="ks-grid-product-list-item__image-link" aria-label="${safeTitle}">
          <span class="ks-grid-product-list-item__image ${this.dataset.imgBorder || ''}">
            <img
              src="${imageSrc}"
              class="img-fluid"
              alt="${safeImageAlt}"
              width="${width}"
              height="${height}"
              loading="lazy"
              decoding="async">
          </span>
        </a>
        <div class="ks-grid-product-list-item__content">
          <div class="ks-grid-product-list-item__top">
            <h4 class="title h5">
              <a href="${safeUrl}" class="full-unstyled-link ks-grid-product-list-item__title-link">
                ${safeTitle}
              </a>
            </h4>
            <button
              class="ks-wishlist-product-item-btn-remove"
              type="button"
              aria-label="${removeLabel}"
              data-product-url="${safeUrl}">
              <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-remove" viewBox="0 0 16 16" width="16" height="16" aria-hidden="true">
                <path fill="currentColor" d="M14 3h-3.53a3.07 3.07 0 0 0-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 0 0 5.53 3H2a.5.5 0 0 0 0 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 0 0 .5-.5V4H14a.5.5 0 0 0 0-1M6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02m4.84 11.52h-7.5V4h7.5z"></path><path fill="currentColor" d="M6.55 5.25a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5m2.9 0a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5"></path>
              </svg>
            </button>
          </div>
          <div class="price">
            <div class="price__container">
              <span class="price-item price-item--last">
                ${window.Shopify.formatMoney(product.price)}
              </span>
            </div>
          </div>
          <div class="ks-grid-product-list-item-added-at">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline>
            </svg>
            <time datetime="${addedAtIso}">${addedAtText}</time>
          </div>
        </div>
      </div>
    `
  }

  setContent () {
    const wishlist = this.sanitizeWishlist(this.wishlist)
    this.wishlist = wishlist

    if (wishlist.length) {
      this.querySelector('.ks-wishlist-empty').setAttribute('hidden', 'hidden')
      this.classList.remove('is-empty')

      const productList = wishlist.map((product) => this.buildProductMarkup(product)).join('')

      this.querySelector('.ks-wishlist-drawer-product-list').innerHTML = productList
      this.querySelector('.ks-wishlist-drawer-product-list-wrapper').removeAttribute('hidden')
    } else {
      this.querySelector('.ks-wishlist-empty').removeAttribute('hidden')
      this.classList.add('is-empty')
      this.querySelector('.ks-wishlist-drawer-product-list').innerHTML = ''
      this.querySelector('.ks-wishlist-drawer-product-list-wrapper').setAttribute('hidden', 'hidden')
    }
  }

  handleRemoveClick (event) {
    const removeBtn = event.target.closest('.ks-wishlist-product-item-btn-remove')
    if (!removeBtn) return

    event.preventDefault()

    this.setProduct(removeBtn.dataset.productUrl).then(() => {
      document.querySelectorAll('.ks-wishlist-btn').forEach((wishlistButton) => {
        wishlistButton.adjustBtn()
      })
    })
  }

  handleImageError (event) {
    const img = event.target
    if (!(img instanceof HTMLImageElement)) return

    const productItem = img.closest('.ks-wishlist-drawer-product-list-item')
    if (!productItem) return

    if (img.dataset.fallbackApplied === 'true') {
      img.src = this.placeholderImage
      return
    }

    img.dataset.fallbackApplied = 'true'

    const productUrl = productItem.dataset.productUrl
    const existingProduct = this.wishlist.find((product) => product.url === productUrl)

    if (!productUrl || !existingProduct) {
      img.src = this.placeholderImage
      return
    }

    this.fetchProductData(productUrl, existingProduct).then((updatedProduct) => {
      if (updatedProduct && this.isRenderableImageSrc(updatedProduct.img_src)) {
        const nextWishlist = this.wishlist.map((product) => {
          if (product.url === productUrl) return updatedProduct
          return product
        })

        this.wishlist = this.sanitizeWishlist(nextWishlist)
        this.setContent()
      } else {
        img.src = this.placeholderImage
      }
    })
  }
}

customElements.define('ks-wishlist-container', KsWishlistContainer)

class KsWishlistBtn extends HTMLElement {
  constructor () {
    super()

    this.btn = this.querySelector('button')
    this.wishlistContainer = document.querySelector('ks-wishlist-container')

    if (!this.btn || !this.wishlistContainer) return

    this.adjustBtn()

    this.btn.addEventListener('click', async (event) => {
      event.preventDefault()

      await this.wishlistContainer.setProduct(this.dataset.productUrl)
      this.syncButtons()
    })
  }

  syncButtons () {
    document.querySelectorAll(`ks-wishlist-btn[data-product-url="${CSS.escape(this.dataset.productUrl || '')}"]`).forEach((wishlistButton) => {
      wishlistButton.adjustBtn()
    })
  }

  adjustBtn () {
    if (!this.btn || !this.wishlistContainer) return

    const isWishlisted = this.wishlistContainer.wishlist.some((elem) => elem.url === this.dataset.productUrl)

    if (isWishlisted) {
      this.btn.classList.add('active')
      this.btn.setAttribute('aria-label', window.kondasoft.wishlist.remove)
      this.btn.setAttribute('aria-pressed', 'true')
    } else {
      this.btn.classList.remove('active')
      this.btn.setAttribute('aria-label', window.kondasoft.wishlist.add)
      this.btn.setAttribute('aria-pressed', 'false')
    }
  }
}
customElements.define('ks-wishlist-btn', KsWishlistBtn)

class KsRecentlyViewedDrawer extends HTMLElement {
  constructor () {
    super()
  
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('.drawer__overlay').addEventListener('click', this.close.bind(this));
    this.setIconsAccessibility()
  }

  setIconsAccessibility() {
    document.querySelectorAll('a[href="#ks-recently-viewed-drawer"]').forEach(link => {
      link.addEventListener('click', (event) => {
        event.preventDefault()
        this.open(link)
      })
      link.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault()
          this.open(link)
        }
      })
    })
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy)

    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active')
    })

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : this.querySelector('.ks-recently-viewed-drawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        window.trapFocus(containerToTrapFocusOn, focusElement)
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden')
  }

  close() {
    this.classList.remove('active')
    window.removeTrapFocus(this.activeElement)
    document.body.classList.remove('overflow-hidden')
  }

  setActiveElement(element) {
    this.activeElement = element
  }
}
customElements.define('ks-recently-viewed-drawer', KsRecentlyViewedDrawer)

class KsRecentlyViewedContainer extends HTMLElement {
  constructor () {
    super()

    this.initTriggers()
    this.setContent()
    this.handleRemoveAll()
  }

  get recentlyViewed () {
    const recentlyViewed = window.KS_SAFE_PARSE_JSON(localStorage.getItem('ks-recently-viewed'), [])
    return Array.isArray(recentlyViewed) ? recentlyViewed : []
  }

  set recentlyViewed (array) {
    try {
      localStorage.setItem('ks-recently-viewed', JSON.stringify(Array.isArray(array) ? array : []))
    } catch (error) {}
  }

  initTriggers () {
    document.querySelectorAll('[data-recently-viewed-set]').forEach(elem => {
      this.setProduct(elem.dataset.productUrl)
    })
  }

  async setProduct (url) {
    let recentlyViewed = this.recentlyViewed
    const isViewed = this.recentlyViewed.some((elem) => elem.url === url)

    if (isViewed) {
      recentlyViewed = this.recentlyViewed.filter((elem) => elem.url !== url)
    }

    try {
      const response = await fetch(`${url}.js`)

      if (!response.ok) {
        throw new Error(`recently_viewed_product_request_failed:${response.status}`)
      }

      const product = await response.json()
      const productImage = product.featured_image || (Array.isArray(product.images) ? product.images[0] : '')

      recentlyViewed.push({
        url,
        id: product.id,
        handle: product.handle,
        title: product.title,
        img_src: productImage,
        img_alt: product.title,
        compare_at_price: product.compare_at_price,
        price: product.price,
        price_varies: product.price_varies,
        added_at: Date.now()
      })
    } catch (error) {
      return
    }

    function keepLastXItemsInArray (arr, x) {
      if (x >= 0 && x <= arr.length) {
        return arr.slice(-x)
      } else {
        return arr
      }
    }

    recentlyViewed = keepLastXItemsInArray(recentlyViewed, Number(this.dataset.limit))

    this.recentlyViewed = recentlyViewed
    this.setContent()
  }

  setContent () {
    if (this.recentlyViewed.length) {
      this.querySelector('.ks-recently-viewed-empty').setAttribute('hidden', 'hidden')
      this.classList.remove('is-empty')

      let productList = ''
      let imgWidth, imgHeight

      switch (this.dataset.imgOrientation) {
        case 'ratio-4x3':
          imgWidth = 600
          imgHeight = Math.round(600 / 4 * 3)
          break
        case 'ratio-3x4':
          imgWidth = Math.round(600 / 4 * 3)
          imgHeight = 600
          break
        default:
          imgWidth = 600
          imgHeight = 600
      }

      this.recentlyViewed.forEach(product => {
        productList += `
  <div class="ks-recently-viewed-drawer-product-list-item ks-grid-product-list-item" role="listitem">
    <a href="${product.url}" class="ks-grid-product-list-item__image-link" tabindex="-1">
      <span class="ks-grid-product-list-item__image">
        <img 
          src="${window.Shopify.resizeImage(product.img_src, `${imgWidth}x${imgHeight}`, 'center')}"
          class="img-fluid ${this.dataset.imgBorder}" 
          alt="${product.img_alt}" 
          width="${imgWidth}" 
          height="${imgHeight}" 
          loading="lazy">
      </span>
    </a>

    <div class="ks-grid-product-list-item__content">
      <div class="ks-grid-product-list-item__top">
        <h4 class="title h5 text-truncate">
          <a href="${product.url}" class="full-unstyled-link ks-grid-product-list-item__title-link">
            ${product.title}
          </a>
        </h4>

        <button 
          class="ks-recently-viewed-product-item-btn-remove"
          type="button"
          aria-label="Remove"
          data-product-url="${product.url}">
          <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-remove" viewBox="0 0 16 16" width="16" height="16"> 
            <path fill="currentColor" d="M14 3h-3.53a3.07 3.07 0 0 0-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 0 0 5.53 3H2a.5.5 0 0 0 0 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 0 0 .5-.5V4H14a.5.5 0 0 0 0-1M6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02m4.84 11.52h-7.5V4h7.5z"></path><path fill="currentColor" d="M6.55 5.25a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5m2.9 0a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5"></path>
          </svg>
        </button>
      </div>

      <div class="price">
        <div class="price__container">
          <span class="price-item price-item--last">
            ${window.Shopify.formatMoney(product.price)}
          </span>
        </div>
      </div>

      <div class="ks-grid-product-list-item-added-at">
        <svg xmlns="http://www.w3.org/2000/svg" class="me-2" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline>
        </svg>
        ${window.Shopify.calcTimeAgo(product.added_at)}
      </div>
    </div>
  </div>
`
      })

      this.querySelector('.ks-recently-viewed-drawer-product-list').innerHTML = productList
      this.querySelector('.ks-recently-viewed-drawer-product-list-wrapper').removeAttribute('hidden')

      this.querySelectorAll('.ks-recently-viewed-product-item-btn-remove').forEach(removeBtn => {
        removeBtn.addEventListener('click', () => {
          const recentlyViewed = this.recentlyViewed.filter((elem) => elem.url !== removeBtn.dataset.productUrl)
          this.recentlyViewed = recentlyViewed
          this.setContent()
        })
      })
      
    } else {
      this.querySelector('.ks-recently-viewed-empty').removeAttribute('hidden')
      this.classList.add('is-empty')
      this.querySelector('.ks-recently-viewed-drawer-product-list').innerHTML = ''
      this.querySelector('.ks-recently-viewed-drawer-product-list-wrapper').setAttribute('hidden', 'hidden')
    }
  }

  handleRemoveAll () {
    document.querySelectorAll('.ks-recently-viewed-btm-remove-all').forEach(btn => {
      btn.addEventListener('click', () => {
        this.recentlyViewed = []
        this.setContent()
      })
    })
  }
}

customElements.define('ks-recently-viewed-container', KsRecentlyViewedContainer)

// class CollectionPagination extends HTMLElement {
//   constructor () {
//     super()

//     this.querySelectorAll('a').forEach(elem => {
//       elem.addEventListener('click', (event) => {
//         event.preventDefault()

//         const params = new URLSearchParams(window.location.search)
//         const newPage = elem.getAttribute('href').split('page=')[1]
//         params.set('page', newPage)
//         const url = `${window.location.pathname}?${params.toString()}`
//         window.history.replaceState({}, '', url)
//       })
//     })
//   }

// }
// customElements.define('collection-pagination', CollectionPagination)